<template>
  <v-card style="background-color: #fafafa;">
    <div class="px-8 py-6">
      <h3>Thông tin phiếu thu {{ detailData.code }}</h3>
      <div class="d-flex justify-space-between my-3">
        <div>
          <div>
            • Ngày tạo phiếu: <strong>{{ formatDate(detailData.createdAt) }}</strong>
          </div>
          <div v-if="historyDetail">
            • Ngày cập nhật cuối cùng:
            <strong>{{ historyDetail.receipt ? formatDate(historyDetail.receipt.updatedAt) : '--' }}</strong>
          </div>
        </div>
        <div v-if="historyDetail">
          <div>
            • Sale tạo phiếu: <strong>{{ historyDetail.receipt.createdByName }}</strong>
          </div>
          <div class="d-inline-flex align-center">
            • Trạng thái:
            <span
              :style="{ color: checkSTATUS_PAY(detailData.status).color }"
              class="mx-2 text-uppercase font-weight-bold"
              >{{ checkSTATUS_PAY(detailData.status).value }}</span
            >
          </div>
          <div 
            class="d-inline-flex align-center ml-2"
            v-if="canShowQrButton(detailData)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small color="#0075ff" class="qr-button" dark v-bind="attrs" v-on="on" @click="showQr = true">
                  <v-icon small>mdi-qrcode</v-icon>
                </v-btn>
              </template>
              <span>Thanh toán qua QR Code</span>
            </v-tooltip>
          </div>
          <qr-payment-modal
            v-model="showQr"
            :code="detailData.code"
            :amount="detailData.amount"
            :receiver-name="historyDetail && historyDetail.receiptShippingAddress ? historyDetail.receiptShippingAddress.receiver : ''"
            :receipt-id="detailData.id"
          />
        </div>
      </div>
      <div class="info-order" style="background-color: #fff;">
        <div>
          • Số tiền thanh toán lần này:
          <span style="color: green" class="font-weight-bold">{{
            formatCurrencyNoD(detailData.amount)
          }} (đ)</span>
        </div>
        <div>
          • Phương thức thành toán: <strong>{{ detailData.paymentMethod == 'MONEY_RECEIPT' ? 'Biên nhận' : detailData.paymentMethod }}</strong>
        </div>
        <div>• Thông tin nhận hàng:</div>
        <div class="px-3" v-if="historyDetail">
          <v-row>
            <v-col cols="3">
              <div>Tên người nhận</div>
              <div>{{ historyDetail.receiptShippingAddress.receiver }}</div>
            </v-col>
            <v-col cols="3">
              <div>Số điện thoại</div>
              <div>{{ historyDetail.receiptShippingAddress.phone }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <div>Tỉnh / TP</div>
              <div>
                {{ historyDetail.receiptShippingAddress.province.vemisTen }}
              </div>
            </v-col>
            <v-col cols="3">
              <div>Quận / Huyện</div>
              <div>
                {{ historyDetail.receiptShippingAddress.district.vemisTen }}
              </div>
            </v-col>
            <v-col cols="3">
              <div>Phường / Xã</div>
              <div>
                {{ historyDetail.receiptShippingAddress.ward.vemisTen }}
              </div>
            </v-col>
            <v-col cols="3">
              <div>Địa chỉ chi tiết(số nhà, đường, thôn, ...)</div>
              <div>
                {{ historyDetail.receiptShippingAddress.addressDetail }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <v-col v-if="historyDetail && historyDetail.orderTrialProducts && historyDetail.orderTrialProducts.length " class="py-3 px-0" cols="12">
          <v-simple-table
            class="table-layout table-products-pay"
            style="background: transparent"
            fixed-header
          >
            <thead>
              <tr>
                <th class="col-program-name text-left">Gói học thử</th>
                <th class="col-expired text-left" style="width: 180px">
                  Thời hạn
                </th>
                <th class="col-total-exchange text-left" style="width: 220px">
                  Thời hạn muốn quy đổi
                </th>
                <th class="col-total-money text-left" style="width: 180px">
                  Thành tiền
                </th>
              </tr>
            </thead>
            <tbody v-if="historyDetail && !loading">
              <template v-for="(item, index) in historyDetail.orderTrialProducts">
                <tr :key="index" v-if="item.productType !== 'sku_combo'">
                  <td class="text-left">
                    <div>{{ findSkuProduct(item).name }}</div>
                    <div style="color: #b70727;font-size:12px">{{item.notFindTrial ? 'Không có gói 1 buổi tương ứng để quy đổi.': ''}}</div>
                  </td>
                  <td>
                    <div class="d-flex pb-2">
                      <div class="string-form">
                        {{ (findSkuProduct(item).numOfLesson * handleTimebyQuanity(item, 'tutor') || findSkuProduct(item).duration) }}
                      </div>
                      <div class="mx-1">
                        {{
                          item.productType === "sku_tutor"
                            ? "(Buổi)"
                            : "(Tháng)"
                        }}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="d-flex pb-2">
                      <div class="string-form">{{ item.totalTrailLessons }}</div>
                      <div class="mx-1">
                        {{
                          item.productType === "sku_tutor"
                            ? "(Buổi)"
                            : "(Tháng)"
                        }}
                      </div>
                    </div>
                  </td>
                  <td class="text-left">
                    <div class="d-flex pb-2">
                      <div class="string-form">
                        {{formatCurrencyNoD(item.totalTrialMoney)}}
                      </div>
                      <div class="mx-1">(đ)</div>
                    </div>
                  </td>
                </tr>
                <template v-if="item.productType === 'sku_combo'">
                  <tr :key="'combo'+index">
                    <td class="text-left">{{item.productName}}</td>
                    <td class="text-left">--</td>
                    <td class="text-left">--</td>
                    <td class="text-left">--</td>
                  </tr>
                  <tr v-for="duo in item.skuDuos" :key="'duoSku' + duo.name">
                    <td class="text-left">
                      <span class="pl-2">● <span class="mx-2">{{ duo.name }}</span></span>
                    </td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{ duo.duration }}
                        </div>
                        <div class="mx-1">
                          (Tháng)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form">{{ duo.totalTrailLessons }}</div> 
                        <span>(Tháng)</span>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                         {{formatCurrencyNoD(duo.totalTrialMoney)}}
                        </div>
                        <div class="mx-1">(đ)</div>
                      </div>
                    </td>
                  </tr>
                  <tr v-for="tutor in item.skuTutors" :key="'tutorSku' + tutor.name">
                    <td class="text-left">
                      <span class="pl-2">● <span class="mx-2">{{ tutor.name }}</span></span>
                    </td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{ tutor.package.split('-')[1] * handleTimebyQuanity(item, 'combo') * Number(tutor.comboDetail && tutor.comboDetail.itemQuantity ? tutor.comboDetail.itemQuantity : 1) }}
                        </div>
                        <div class="mx-1">
                          (Buổi)
                        </div>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex">
                        <div class="string-form">{{ tutor.totalTrailLessons }}</div>
                        <span>(Buổi)</span>
                      </div>
                    </td>
                    <td class="text-left">
                      <div class="d-flex pb-2">
                        <div class="string-form">
                          {{formatCurrencyNoD(tutor.totalTrialMoney)}}
                        </div>
                        <div class="mx-1">(đ)</div>
                      </div>
                    </td>
                  </tr>
                </template> 
              </template>
            </tbody>
          </v-simple-table>
        </v-col>
      <v-row v-if="historyDetail && historyDetail.orderTrialProducts && historyDetail.orderTrialProducts.length">
        <v-col class="text-end">
          <strong>• Tổng tiền quy đổi lần này: {{formatCurrencyNoD(totalMoney())}} (đ)</strong>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-3" cols="6 ">
          <span class="font-weight-bold">
            <v-icon color="#0075ff"> mdi-message-text-outline </v-icon>
            Note cho vận đơn
          </span>
        </v-col>
        <v-col class="py-3" cols="6 ">
          <span class="font-weight-bold">
            <v-icon color="#0075ff"> mdi-message-text-outline </v-icon>
            Note cho vận hành
          </span>
        </v-col>
      </v-row>
      <v-row v-if="historyDetail">
        <v-col class="py-0" cols="6">
          <v-textarea
            outlined
            rows="3"
            disabled
            class="ma-0 pa-0 text-area-custom backgroundColorW"
            :value="historyDetail.orderReceiptNote ? historyDetail.orderReceiptNote.description : ''"
          />
        </v-col>
        <v-col class="py-0" cols="6">
          <v-textarea
            outlined
            rows="3"
            disabled
            class="ma-0 pa- text-area-custom backgroundColorW"
            :value="historyDetail.orderReceiptNote ? historyDetail.orderReceiptNote.noteSortClass : ''"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-end">

          <v-btn
            class="btn-cancel mx-0"
            color="#b70727"
            height="38"
            width="100"
            @click="close()"
          >
            Đóng
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import { STATUS_PAY } from "@/helpers/constants";
import { ORDER_OPERATION_TYPE } from "@/helpers/constants";
import RepositoryFactory from "../../../repositories/RepositoryFactory";
import TokenService from "@/helpers/token";
const OrderRepository = RepositoryFactory.get("order");

export default {
  components: { QrPaymentModal: () => import('@/components/common/QrPaymentModal.vue') },
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
    skuTutors: {
      type: Array,
      default: () => [],
    },
    skuDuos: {
      type: Array,
      default: () => [],
    },
    skuCombos: {
      type: Array,
      default: () => [],
    },
    detailOrder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      STATUS_PAY,
      historyDetail: null,
      loading: false,
      showQr: false,
    };
  },
  computed: {},
  async mounted() {
    if (typeof Bus !== 'undefined' && Bus) {
      Bus.$on('transfer-qr-code-success', this.handleTransferQrCodeSuccess);
    }
    await this.getData();
  },
  beforeDestroy() {
    if (typeof Bus !== 'undefined' && Bus) {
      Bus.$off('transfer-qr-code-success', this.handleTransferQrCodeSuccess);
    }
  },
  methods: {
    handleTransferQrCodeSuccess(data = {}) {
      if (!this.showQr) {
        return;
      }
      const targetReceiptId = data && data.receiptId ? String(data.receiptId) : '';
      if (this.detailData && this.detailData.id && targetReceiptId && String(this.detailData.id) !== targetReceiptId) {
        return;
      }
      this.showQr = false;
    },
    totalMoney() {
      let total = 0;
      if (this.historyDetail && this.historyDetail.orderTrialProducts) {
        this.historyDetail.orderTrialProducts.forEach((item) => {
          if (item.productType === "sku_combo") {
            _.get(item, 'skuTutors', []).forEach((tutor) => {
              total += Number(tutor.totalTrialMoney);
            });
            _.get(item, 'skuDuos', []).forEach((duo) => {
              total += Number(duo.totalTrialMoney);
            });
          } else {
            total += Number(item.totalTrialMoney);
          }
        });
      }
      return total;
    },
    checkSTATUS_PAY(status) {
      return this.STATUS_PAY.find((item) => item.key === status);
    },
    canShowQrButton(data) {
      if (this.detailOrder.metadata.operationType !== ORDER_OPERATION_TYPE.NORMAL_ORDER) {
        return false;
      }
      return (
        (
          (data.paymentMethod === 'COD' && (data.status === 'init' || data.status === 'in_progress')) ||
          (data.paymentMethod === 'BANK' && data.status === 'in_progress')
        ) &&
        Number(data.amount) > 0
      );
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("HH:mm:ss - DD/MM/YYYY");
      }
      return "";
    },
    async getData() {
      const res = await OrderRepository.getHistoryOrderDetail(
        this.detailData.id
      );
      if (res && res.data) {
        this.historyDetail = res.data;
        this.loading = true;
        for (const item of this.historyDetail.orderTrialProducts) {
          const index = this.historyDetail.orderTrialProducts.indexOf(item);
            await this.getBaseSku(item);
            if (index === this.historyDetail.orderTrialProducts.length - 1) this.loading = false;
        }
      }
    },
     async getBaseSku(product) {
      const type = product.productType.split("_")[1];
      if (type === "combo") {
        const params = {
          product_type: type,
          include_price_policy: 1,
          transaction_status: "selling",
          status: "active",
          num_of_lesson: 1,
          include_sku_tutor_payment_unit: 1,
          is_from_crm: 1,
          sku_ids: [product.productId],
        };
        const res = await OrderRepository.advanceSearchForCombo(params);
        if (res && res.data && res.data.length) {
          product.productName = res.data[0].name;
          product.skuTutors = res.data[0].skuTutors.map((item) => {
            return {
              ...item,
              totalTrailLessons: product.items.find((i) => i.productId === item.id).totalTrailLessons,
              totalTrialMoney: product.items.find((i) => i.productId === item.id).totalTrialMoney,
              package: `${item.classTypeId}-${item.numOfLesson}`,
            };
          });
          product.skuDuos = res.data[0].skuDuos.map((item) => {
            return {
              ...item,
              totalTrailLessons: product.items.find((i) => i.productId === item.id).totalTrailLessons,
              totalTrialMoney: product.items.find((i) => i.productId === item.id).totalTrialMoney,
            };
          });
        } else {
          product.notFindTrial = true;
        }
      }
    },
    findSkuProduct(product) {
      if (product.productType === "sku_tutor") {
        return this.skuTutors.find((item) => item.id === product.productId);
      }
      if (product.productType === "sku_duo") {
          return this.skuDuos.find((item) => item.id === product.productId);
      }
      // if (product.productType === "Combo") {
      //     return this.skuCombos.find((item) => item.id === product.skuId);
      // }
    },
    formatCurrencyNoD(val) {
      const cv = parseInt(val);
      const res =
        cv.toLocaleString("it-IT", { style: "currency", currency: "VND" }) ||
        "";
      return res.slice(0, -3);
    },
    handleTimebyQuanity(item, type) {
      if (type === "combo") {
        const data = this.detailOrder.combos.find((combo) => combo.productId === item.productId);
        if (data) {
          return data.quantity;
        }
      } else {
        const data = this.detailOrder.orderProducts.find((product) => product.productId === item.productId);
        if (data) {
          return data.quantity;
        }
      }
      return 0;
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.info-order {
  border-radius: 10px;
  border: 1px solid #989898;
  padding: 16px 8px;
}

.qr-button {
  transition: all 0.3s ease;
}

.qr-button:hover {
  background-color: transparent !important;
  border: 1px solid #0075ff !important;
  color: #0075ff !important;
}

.qr-button:hover .v-icon {
  color: #0075ff !important;
}
</style>
<style lang="scss">
.backgroundColorW {
  .v-input__slot {
    background: #fff !important;
  }
}
</style>
